"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainPairConfig_1 = __importDefault(require("./onchainPairConfig"));
class OnchainProposal {
    constructor(configManager, proposalId) {
        this.pairConfigs = {};
        this.cache = {};
        this.getConfigManager = () => this.configManager;
        this.getProposalId = () => this.proposalId;
        this.getOnchain = () => this.configManager.getOnchain();
        this.configManager = configManager;
        this.proposalId = proposalId;
    }
    cleanCache() {
        this.cache = {};
    }
    getProposalData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.proposalData)
                this.cache.proposalData = (() => __awaiter(this, void 0, void 0, function* () {
                    const configManagerContract = yield this.configManager.getConfigManagerContract();
                    return configManagerContract.methods.getProposal(this.proposalId).call();
                }))();
            return this.cache.proposalData;
        });
    }
    getPairConfig(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.pairConfigs[index]) {
                const proposalData = yield this.getProposalData();
                this.pairConfigs[index] = new onchainPairConfig_1.default(this, proposalData[index]);
            }
            return this.pairConfigs[index];
        });
    }
    getPairConfigsLength() {
        return __awaiter(this, void 0, void 0, function* () {
            const proposalData = yield this.getProposalData();
            return proposalData.length;
        });
    }
}
exports.default = OnchainProposal;
